/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class MultiBanner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            index: Math.floor(Math.random() * this.props.promotions.length),
            promotions: this.props.promotions,
            content: this.props.content
        };

        this.onClick = this.onClick.bind(this);

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.user.detail.pubLevel === 0 && this.props.user.detail.pubLevel !== 0) {
            this.setState({
                index: Math.floor(Math.random() * this.props.promotions.length),
                promotions: this.props.promotions,
                content: this.props.content
            });
        }
    }

    componentDidMount() {

        if (dataLayer) {
            // dataLayer.push({
            //     'event': 'promotionView',
            //     'ecommerce': {
            //         'promoView': {
            //             'promotions': [this.state.promotions[this.state.index]]
            //         }
            //     },
            //     //GA 4 params
            //     'promotion_id': this.state.promotions[this.state.index].id,
            //     'promotion_name': this.state.promotions[this.state.index].name,
            //     'creative_name': this.state.promotions[this.state.index].creative,
            //     'creative_slot': this.state.promotions[this.state.index].position,
            //     items: [
            //         {
            //             item_id: 'dlvrit_1',
            //             item_name: 'dlvr.it premium plan',
            //             price: 1.00,
            //             quantity: 1
            //         }
            //     ]
            // });
        }

        if (gtag) {
            gtag('event', 'view_promotion', {
                promotion_id: this.state.promotions[this.state.index].id,
                promotion_name: this.state.promotions[this.state.index].name,
                creative_name: this.state.promotions[this.state.index].creative,
                creative_slot: this.state.promotions[this.state.index].position,
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });
        }

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner View',
                event_data: {
                    banner: this.state.promotions[this.state.index].name
                }
            });
        }

    }

    onClick(e) {

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Banner Click',
                event_data: {
                    banner: this.state.promotions[this.state.index].name
                }
            });
            console.log("recorded banner click");
        }

        // if (dataLayer && window.ga && ga.loaded) {
        //     dataLayer.push({
        //         'event': 'promotionClick',
        //         'ecommerce': {
        //             'promoClick': {
        //                 'promotions': [this.state.promotions[this.state.index]]
        //             }
        //         },
        //         //GA 4 params
        //         'promotion_id': this.state.promotions[this.state.index].id,
        //         'promotion_name': this.state.promotions[this.state.index].name,
        //         'creative_name': this.state.promotions[this.state.index].creative,
        //         'creative_slot': this.state.promotions[this.state.index].position,
        //         items: [
        //             {
        //                 item_id: 'dlvrit_1',
        //                 item_name: 'dlvr.it premium plan',
        //                 price: 1.00,
        //                 quantity: 1
        //             }
        //         ]
        //     });
        // }

        if (gtag) {
            gtag('event', 'select_promotion', {
                promotion_id: this.state.promotions[this.state.index].id,
                promotion_name: this.state.promotions[this.state.index].name,
                creative_name: this.state.promotions[this.state.index].creative,
                creative_slot: this.state.promotions[this.state.index].position,
                items: [
                    {
                        item_id: 'dlvrit_1',
                        item_name: 'dlvr.it premium plan',
                        price: 1.00,
                        quantity: 1
                    }
                ]
            });

            this.props.persistData('gaPromo', {
                promotion_id: this.state.promotions[this.state.index].id,
                promotion_name: this.state.promotions[this.state.index].name
            });
        }

    }

    render() {
        let constants = this.props.app.config.constants,
            banner = null,
            target = '';

        banner = this.state.content[this.state.index];

        if (!banner) {
            return null;
        }

        target = (this.props.target === 'tab' || banner.linkDestination.match('https')) ? "_blank" : "_self";

        if (this.props.user.detail.pubLevel > 1) {
            if (banner && banner.linkDestination && banner.linkDestination.match("subscription")) {
                banner.linkDestination = banner.linkDestination.replace("/new?plan=9&", "/plus?");
            }
        }

        let icon = null;
        if (typeof banner.icon === "string") {
            icon = (
                <div className="icon-wrapper">
                    <i className={banner.icon}></i>
                </div>
            );
        } else {
            icon = (
                <div className="icon-wrapper">
                    {banner.icon}
                </div>
            );
        }

        return (
            <div>
                {icon}
                <span>{banner.content} <a href={banner.linkDestination} target={target} onClick={this.onClick}>{banner.linkContent}</a></span>
            </div>
        );
    }
}

MultiBanner.propTypes = {
    promotions: PropTypes.array,
    content: PropTypes.array,
    target: PropTypes.string
};

MultiBanner.defaultProps = {
    promotions: [],
    content: [],
    target: 'self'
};

export default MultiBanner;
